module.exports = __webpack_public_path__ + "static/media/g-icon-add.9f0d2b0a.svg";